export default __webpack_public_path__ + "static/media/25.07b25933.png";